import { render, staticRenderFns } from "./DateTime.vue?vue&type=template&id=c19cff38&scoped=true"
import script from "./DateTime.vue?vue&type=script&lang=js"
export * from "./DateTime.vue?vue&type=script&lang=js"
import style0 from "./DateTime.vue?vue&type=style&index=0&id=c19cff38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19cff38",
  null
  
)

export default component.exports